import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    deleteGuideInterest,
    deleteGuideInterestVariables,
} from "./__graphql-types__/deleteGuideInterest.ts";

export const DELETE_INTEREST_MUTATION: GqlOperation<
    deleteGuideInterest,
    deleteGuideInterestVariables
> = gqlOp(gql`
    mutation deleteGuideInterest($kaid: String!, $key: String!) {
        deleteInterest(kaid: $kaid, combinedKey: $key) {
            error {
                code
                debugMessage
            }
        }
    }
`);
